import { Eye } from 'lucide-react';

import type { TFunction } from 'i18next';

import type { ReceiveHistoryTableData } from '@/entities/receive';
import type { TableAction } from '@/shared/ui/data-table';

interface BuildReceiveHistoryRowActionsArgs {
  onShowDisposition: (consignmentId: string) => void;
  t: TFunction;
}

/**
 * Per-row actions for the receive history table — mirrors the first action of
 * the consignments table: open the consignment's Line Disposition dialog.
 */
export function buildReceiveHistoryRowActions({
  onShowDisposition,
  t
}: BuildReceiveHistoryRowActionsArgs): TableAction<ReceiveHistoryTableData>[] {
  return [
    {
      id: 'show-disposition',
      label: t('cmrlist.showdisposition.label', 'Show Disposition'),
      icon: Eye,
      onClick: (row) => onShowDisposition(row.consignmentId)
    }
  ];
}
